module.exports = __webpack_public_path__ + "public/images/reading.1ea97a5febb898d82a8bca2fdb9210d4.png";